import React from 'react';
import {useSelector} from 'react-redux';
import {createSelector} from 'reselect';

import WhatHappenedModal from '../WhatHappenedModal/WhatHappenedModal';
import makeSrpUrl from '../../../../../shared/utils/makeSrpUrl';

import {
  checkinSelectorFn,
  checkoutSelectorFn,
  roomStringSelectorFn,
  hotelsPartnerFn,
} from '../../../common/redux/selectors';

import {
  cityId as cityIdSelector,
  cityNameSelector,
  detailHttpCodeSelector,
  hotelIdSelector,
  hasStaticDataSelector,
} from '../../selectors';

import {allFirstLevelObjectKeysAreNonNullable} from '../../../../../shared/utils/common-utils';

const defaultRedirectUrl = '/hotels/';

const voyagerStatusHandlerSelector = createSelector(
  [
    checkinSelectorFn,
    checkoutSelectorFn,
    roomStringSelectorFn,
    cityIdSelector,
    cityNameSelector,
    hotelsPartnerFn,
  ],
  (checkinObj, checkoutObj, roomString, cityId, cityName, hotelsPartner) => ({
    checkinObj,
    checkoutObj,
    roomString,
    cityId,
    cityName,
    hotelsPartner,
  }),
);

const VoyagerStatusHandler = () => {
  const {checkinObj, checkoutObj, roomString, cityId, cityName, hotelsPartner} = useSelector(
    voyagerStatusHandlerSelector,
  );

  const voyagerStatus = useSelector(detailHttpCodeSelector);
  const hotelId = useSelector(hotelIdSelector);
  const hasStaticData = useSelector(hasStaticDataSelector);
  const noHotelId = !hotelId;

  const thereIsVoyagerError =
    hasStaticData && (voyagerStatus.startsWith('4') || voyagerStatus.startsWith('5') || !hotelId);

  const homePartner = useSelector(hotelsPartnerFn);
  const homePath = `/${homePartner}/`;

  const destination = {
    _id: cityId,
    n: cityName,
  };

  const srpMakingOptions = {
    checkin: checkinObj,
    checkout: checkoutObj,
    roomString,
    destination,
    partner: hotelsPartner,
  };

  let srpUrl = '';

  if (allFirstLevelObjectKeysAreNonNullable(srpMakingOptions) && cityName && cityId) {
    srpUrl = makeSrpUrl(srpMakingOptions);
  }

  const displayMessage = srpUrl ? `More Hotels in ${cityName}` : 'Home Page';

  let modalTitle = '';

  const somethingWentWront = 'Something Went Wrong';

  if (voyagerStatus === '410') {
    modalTitle = 'Hotel Is Currently Unavailable';
  } else {
    /**
     * this error message can be improved upon if we have an exhaustive list of all error codes and cases     from voyager
     */
    modalTitle = somethingWentWront;
  }

  if (noHotelId) {
    modalTitle = somethingWentWront;
  }

  let redirectUrl = homePath;

  if (srpUrl) {
    redirectUrl = srpUrl;
  }

  if (noHotelId) {
    redirectUrl = homePath;
  }

  if (!thereIsVoyagerError) {
    return null;
  }

  return (
    <WhatHappenedModal
      title={modalTitle}
      redirect={{
        shouldRedirect: true,
        to: redirectUrl || defaultRedirectUrl,
        after: 8,
        displayText: displayMessage,
      }}
    />
  );
};

export default VoyagerStatusHandler;
